<template>
  <div>
    <el-form ref="formRef" :model="tagForm" label-width="88px">
      <el-form-item label="类目名称：">
        <el-input type="text" v-model="tagForm.name" placeholder="请输入类目名称" style="width:24em;"/>
      </el-form-item>
      <el-form-item label="排序：">
        <el-input type="text" v-model="tagForm.orderNum" placeholder="数字越大排序越靠前" style="width:24em;"/>
      </el-form-item>
      <el-form-item label="图片：">
        <img :src="src" alt="" v-if="src" @click="headImgUpdate" class="cursor" style="width: 80px;height: 80px;margin: 0">
        <div class="add" @click="headImgUpdate" v-else>
          <span>+</span>
        </div>
        <input type="file" accept=".jp2,.jpe,.jpeg,.jpg,.png"  @change="headImgChanged" ref="headImg" multiple="multiple" style="display:none;">
      </el-form-item>
    </el-form>
    <div class="dialog-footer" style="text-align: center">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit" v-loading="loading">确定</el-button>
    </div>
  </div>

</template>

<script>
import {imgPostFormData, postFormData} from "@/api/api"
import { updateOrAddInfoLabel } from "@/api/url";

export default {
  name: "TagManageDialog",
  props: {
    value: Object
  },
  data() {
    return {
      tagForm: this.value.tagForm,
      infoLabelTypeId: this.value.infoLabelTypeId,

      files: null,
      src: this.value.ids > -1?this.value.tagForm.img:'',

      idx: this.value.ids,
      loading: false,

      names: [],

    }
  },
  methods: {
    cancel() {
      this.$emit("close");
    },

    //更改或添加
    headImgUpdate() {
      this.$refs.headImg.click();
    },

    //选取图片
    headImgChanged(e) {
      if(e.target.files[0]) {
        this.files = e.target.files[0];
        var windowURL = window.URL || window.webkitURL;
        this.src = windowURL.createObjectURL(this.files);
      }
    },

    summit() {
      if(!this.tagForm.name) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '类目名称不能为空',
          type: 'warning'
        });
        return false
      }
      if(!this.tagForm.orderNum) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '排序不能为空',
          type: 'warning'
        });
        return false
      }
      if(!this.src) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '图片不能为空',
          type: 'warning'
        });
        return false
      }
      this.loading = true
      let param = new FormData();
      if (this.idx > -1) {
        param.append('id', this.tagForm.id);
      } else {
        param.append('id', '0');
      }
      param.append('name', this.tagForm.name);
      param.append('orderNum', this.tagForm.orderNum);
      param.append('infoLabelTypeId', this.infoLabelTypeId);
      param.append('file', this.files);
      // param['infoLabelNameArr'] = this.infoLabelList.split('\n');
      imgPostFormData(updateOrAddInfoLabel, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm')
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
        this.loading = false
      }).catch(()=>{
        this.loading = false
      })
    }
  },
  mounted() {
  }
}
</script>

<style scoped>
.add {
  width: 80px;
  height: 80px;
  text-align: center;
  line-height: 80px;
  border: 1px dashed #ececec;
  font-size: 30px;
  cursor: pointer;
  float: left;
}
</style>
